import React, { useRef } from 'react';
import querystring from 'querystring';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import { FullContentWrapper } from '../styles/styled';
import { SoundwiseHeader } from '../components/soundwise_header';
import Footer from '../components/footer';
import CustomDialog from './dashboard/components/custom_dialog';
import Pricing from '../components/pricing';

const _Pricing = props => {
  const alertDialog = useRef(null);

  const goToCheckout = (plan, frequency, promo = null) => {
    const raw = {
      plan,
      frequency,
      promo,
    };
    const query = querystring.stringify(omitBy(raw, isEmpty));
    window.location.href = `/buy?${query}`;
  };

  const showAlertModal = (metadata = {}) => {
    alertDialog.current.showModal(metadata);
  };

  return (
    <FullContentWrapper>
      <Helmet>
        <title>Pricing</title>
        <meta property="og:url" content="https://mysoundwise.com/pricing" />
        <meta property="fb:app_id" content="1726664310980105" />
        <meta property="og:title" content="Pricing" />
        <meta
          property="og:description"
          content="All pricing plans allow unlimited listener signups."
        />
        <meta property="og:image" content="https://mysoundwise.com/images/soundwise_homepage.png" />
        <meta name="description" content="All pricing plans allow unlimited listener signups." />
        <meta
          name="keywords"
          content="soundwise, training, online education, education software, subscription, soundwise inc, real estate, real estate broker, real estate agents, real estate brokerage, real estate training, audio publishing, content management system, audio, mobile application, learning, online learning, online course, podcast, mobile app"
        />
        <meta name="twitter:title" content="Pricing" />
        <meta
          name="twitter:description"
          content="All pricing plans allow unlimited listener signups."
        />
        <meta
          name="twitter:image"
          content="https://mysoundwise.com/images/soundwise_homepage.png"
        />
        <meta name="twitter:card" content="https://mysoundwise.com/images/soundwise_homepage.png" />
        <link href="/css/rc-collapse.css" rel="stylesheet"></link>
      </Helmet>
      <SoundwiseHeader showIcon={true} />
      <Pricing
        goToCheckout={goToCheckout}
        userInfo={props.userInfo}
        showAlertModal={showAlertModal}
      />
      <CustomDialog ref={alertDialog} />
      <Footer showPricing={true} />
    </FullContentWrapper>
  );
};

const mapStateToProps = state => {
  const { userInfo } = state.user;
  return { userInfo };
};

export default connect(mapStateToProps)(_Pricing);
